var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 153,
    viewBox: "0 0 217 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_211730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 97,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33865 0H103.15V139.215H7.33865V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_211730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8989 38.2369C41.7604 38.0941 40.1626 35.9376 40.3303 33.4223L41.5737 14.7486C42.0126 14.1763 42.4956 13.7095 43.0202 13.3998C45.5978 11.9213 48.4294 12.1099 50.7924 13.9171C53.3674 15.948 54.1733 22.2901 53.686 25.3938C53.0309 29.8452 52.3741 34.301 51.7176 38.7568L43.8989 38.2369Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.298 42.5391C70.298 42.5391 75.5571 46.2443 79.3956 68.5892C83.2341 90.9304 80.7913 90.081 80.7913 90.081L80.096 95.1702L70.3226 96.0196L64.7409 76.7868L70.298 42.5391Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4538 111.859C50.4538 111.859 58.0455 155.292 65.955 174.357C72.9667 191.246 81.1435 169.275 81.1435 169.275L68.3469 96.3969L47.256 94.7969C47.256 94.7969 45.8039 95.3314 50.4538 111.859Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2128 94.9726L54.8046 122.978L51.1495 125.127C51.1495 125.127 49.0318 166.727 48.342 168.832C44.3864 180.874 34.1549 173.65 32.7592 169.634C31.3635 165.621 29.0353 135.913 29.4995 114.238C29.9656 92.5635 29.9656 92.5635 29.9656 92.5635L52.2128 94.9726Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5891 42.5165L55.1981 35.5674L47.2593 37.9436L37.4434 36.8232L26.6224 41.5097C26.6224 41.5097 21.7412 46.2034 26.2754 61.2843C30.8132 76.3652 30.1355 101.266 30.1355 101.266L69.4149 103.755C69.4149 103.755 66.7499 50.8936 70.5891 42.5165Z",
    fill: "#D1DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7298 41.7988C29.7298 41.7988 23.1197 39.4665 18.3908 47.9424C10.3271 62.3862 8.08494 78.9572 7.54856 82.1792C7.01511 85.4048 7.18389 94.7704 11.8989 96.7328C16.6194 98.6989 21.7569 97.3369 21.7569 97.3369L26.4496 83.6986L23.0768 82.6735L22.8293 82.6112C22.8293 82.6112 24.7321 76.0685 28.3443 65.3482C31.9577 54.6316 29.7298 41.7988 29.7298 41.7988Z",
    fill: "#D1DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3185 37.6034L41.4375 41.8432L37.5555 36.2487L39.8844 32.7998L45.3185 37.6034Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.842 33.1328L46.3774 37.9438L49.9047 42.1799L55.7313 35.5676L53.842 33.1328Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6716 31.8475C42.533 31.7047 40.9353 29.5482 41.1029 27.0296L42.346 8.35732C42.7853 7.78506 43.2682 7.31824 43.7929 7.00813C46.3705 5.5297 49.2021 5.71826 51.5651 7.52584C54.1397 9.55639 54.9459 15.8989 54.4586 19.0022C53.8036 23.4539 53.1468 27.9108 52.4903 32.3674L44.6716 31.8475Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6693 3.64055L48.9098 0.03125L50.4003 0.130471L54.3311 0.392254L56.7047 0.550056C59.324 0.724333 61.3084 2.9936 61.1338 5.61582L60.8936 9.2233L59.402 9.12408L55.4731 8.86266L53.0998 8.70449C50.478 8.53022 48.4946 6.26314 48.6693 3.64055Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.742 25.0504C39.5864 27.3808 41.3504 29.3949 43.6811 29.5523L53.262 30.1894C55.5928 30.3432 57.6076 28.5806 57.7625 26.2506L59.0381 7.09429C59.1933 4.76168 57.4304 2.74394 55.0996 2.5887L45.5188 1.95091C43.188 1.79567 41.1724 3.56151 41.0172 5.89485L39.742 25.0504Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6071 0.0106353C46.9467 -0.0999358 45.4287 0.660149 44.4951 1.8951L42.8665 1.78673C40.8352 1.65163 39.0808 3.18937 38.9453 5.22029L38.3404 14.3076L40.926 14.4801L41.1721 10.7844C41.2673 9.35756 42.507 8.27381 43.9327 8.36864L45.443 8.46896L49.3734 8.73074L51.7448 8.88854C54.3714 9.06355 56.6334 7.0806 56.808 4.45838L57.0669 0.573742L48.6071 0.0106353Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5855 16.8935C41.6682 15.6501 40.7276 14.5788 39.4806 14.4957L39.2964 14.4836C38.0523 14.4009 36.9763 15.3374 36.8935 16.5812L36.7112 19.3183C36.6284 20.5606 37.5705 21.637 38.8146 21.7198L38.9988 21.7319C39.9203 21.7934 40.7478 21.2929 41.1516 20.5258",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7637 69.709L80.3806 79.7885L88.2967 92.0685L89.3577 92.5994L98.8654 71.0124L97.7637 69.709Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.701 69.9951L100.008 70.9324L91.6836 89.2133L91.1941 93.0906C91.1941 93.0906 92.3775 93.01 92.5404 92.805C92.7037 92.6 102.701 69.9951 102.701 69.9951Z",
    fill: "#003E99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3851 66.5244L67.119 66.6086C67.119 66.6086 77.0751 74.3999 79.9317 78.3174C82.7882 82.235 88.4398 89.0926 88.8682 91.6226C88.9747 92.2487 89.0483 92.4537 89.0721 92.6221C89.1131 92.9077 89.0721 91.4981 89.0721 91.4981C89.0721 91.4981 89.0314 87.2144 90.0108 84.765C90.9899 82.3192 97.7636 69.7097 97.7636 69.7097C97.7636 69.7097 100.539 70.7715 101.069 70.8521C101.599 70.9326 91.7653 92.5599 91.7653 92.5599C91.7653 92.5599 90.9086 93.64 89.6026 93.3141C88.2966 92.9883 87.6237 93.3141 86.6648 92.029C86.3953 91.6665 85.6447 89.9494 85.6447 89.9494L64.3851 66.5244Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.018 64.8545L62.6711 64.8105L86.9093 90.846C86.9093 90.846 87.1136 91.3769 87.0319 91.6625C86.9503 91.9481 87.423 92.8963 88.4803 92.9879C89.4722 93.0757 90.9301 93.3064 91.7653 92.9659C92.5795 92.6364 102.701 69.9949 102.701 69.9949L103.15 70.2L93.0302 92.1531C93.0302 92.1531 93.2752 92.7243 92.9486 92.9256C92.622 93.1307 91.0308 93.8666 90.6226 93.9069C90.2147 93.9471 65.9356 104.107 65.9356 104.107L62.7934 102.884L61.814 101.332L45.4513 84.1129L62.018 64.8545Z",
    fill: "#0450CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8393 82.89L62.0181 64.8545L86.2976 91.1719L62.6712 102.313L43.7376 84.0324L44.8393 82.89Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5559 79.4195C36.5559 79.4195 37.9025 78.8081 40.7994 77.5449C43.6965 76.2781 45.6963 74.3193 46.5531 74.3999C47.4102 74.4841 52.1025 77.1751 52.1025 77.1751L58.9579 80.4813C58.9579 80.4813 60.2635 81.6236 59.9373 82.3193C59.6107 83.0112 59.3251 82.971 58.713 82.9307C58.1008 82.8904 51.613 80.5216 51.613 80.5216L60.6308 85.4606L63.2424 87.1339C63.2424 87.1339 63.8135 87.705 63.8545 88.1517C63.8952 88.602 63.6912 89.1732 63.1201 89.1329C62.5489 89.0926 62.1407 89.1732 61.5285 88.8473C60.9167 88.5215 56.7952 86.6432 56.7952 86.6432C56.7952 86.6432 61.3246 88.8071 62.1407 89.7041C62.9568 90.6011 62.9162 91.0075 62.7529 91.4578C62.5896 91.9082 61.9774 91.9887 61.9774 91.9887L58.4684 90.1508C58.4684 90.1508 59.4884 90.7219 59.4068 90.9672C59.3251 91.2125 58.9986 91.6226 58.5497 91.5823C58.1008 91.5384 54.184 90.235 54.184 90.235L50.3887 89.338L45.4514 88.8071L39.2898 87.2547C39.2898 87.2547 38.1881 87.5403 38.0658 87.1741C37.9432 86.808 34.9644 80.9719 36.5559 79.4195Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7935 102.884L86.1342 92.0684C86.1342 92.0684 86.4198 92.764 87.6032 93.2949C88.7865 93.8258 91.2348 93.7013 91.2348 93.7013L65.9356 104.107C65.9356 104.107 62.9161 103.821 62.7935 102.884Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3806 98.2304C80.3806 98.2304 80.7482 98.8857 80.3806 99.823C80.0133 100.76 79.9317 101.331 78.9523 101.657C77.9733 101.983 77.8916 102.027 77.4017 101.617C76.9122 101.211 74.8312 99.618 74.8312 99.618L73.1989 97.4139C73.1989 97.4139 72.7094 96.396 73.3622 96.1507C74.015 95.9054 74.5866 95.8249 75.4433 96.7622C76.3001 97.6995 77.8916 98.5159 78.3405 98.721C78.8179 98.937 80.3806 98.2304 80.3806 98.2304Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9733 101.456C77.9733 101.456 78.2589 102.189 77.8917 102.679C77.5245 103.17 76.79 103.781 76.1778 103.741C75.5657 103.701 71.6484 101.658 71.6484 101.658L68.6696 97.2532L66.303 93.6614C66.303 93.6614 66.5479 92.8852 67.0374 92.8047C67.5269 92.7241 67.8535 92.6399 68.425 93.1708C68.9962 93.7017 70.9956 96.7625 70.9956 96.7625L73.6885 98.9264C73.6885 98.9264 77.1162 101.127 77.9733 101.456Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3856 94.1926C62.3856 94.1926 62.5895 93.0906 63.2423 93.2114C63.8951 93.3359 64.9972 94.4379 66.1805 95.7011C67.3638 96.9679 67.9756 97.7002 67.9756 97.7002L70.0571 99.1683L74.7087 102.639L75.1166 103.17C75.1166 103.17 75.6471 103.943 74.9127 104.148C74.1782 104.353 73.6883 105.169 72.5054 104.638C71.322 104.107 67.4455 101.211 67.4455 101.211L64.9972 97.9455L63.2654 95.4558L62.3856 94.1926Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5896 95.3753C62.0594 95.3973 61.9368 96.1113 61.9368 96.1113L65.854 101.863C65.854 101.863 70.424 105.129 70.8733 105.374C71.3221 105.616 72.2605 105.455 72.5055 104.638C72.75 103.822 66.2212 98.8865 66.2212 98.8865C66.2212 98.8865 63.6503 95.3351 62.5896 95.3753Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5152 85.1051L37.3204 79.0713C38.2643 80.3235 38.9135 81.7697 39.1445 83.366L39.5827 86.4012C30.8941 92.8963 21.1708 98.6922 17.1386 95.7741C9.09954 89.9636 19.5152 85.1051 19.5152 85.1051Z",
    fill: "#F7B68B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.498 96.986C167.743 79.8585 145.708 37.6474 123.326 65.8174C112.255 78.6722 102.755 102.928 99.1849 120.034C97.5241 128.246 97.0972 134.943 98.1264 140.369H202.973C206.367 132.475 207.547 124.636 206.746 119.36C205.452 109.621 198.541 106.505 188.498 96.986Z",
    fill: "#EAF4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.591 113.458C137.802 119.152 142.115 133.05 144.73 141.013H185.313L192.572 121.052C192.572 121.052 207.935 97.1288 181.484 81.2571C177.687 78.9798 157.943 80.653 157.943 80.653C157.943 80.653 143.317 81.6306 123.922 110.723C123.315 111.635 137.288 105.257 137.591 113.458Z",
    fill: "#212957"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.892 67.2857C162.195 68.8051 164.823 73.4037 153.387 83.9922C145.185 91.5857 171.309 92.4974 180.422 80.9533C180.422 80.9533 166.448 79.1336 171.005 53.6181C174.424 34.4695 161.892 67.2857 161.892 67.2857Z",
    fill: "#F7B68B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.918 93.1052L150.45 95.3313C150.45 95.3313 148.341 96.3125 148.83 96.5981C149.438 96.9532 153.69 95.6352 153.69 95.6352C153.69 95.6352 154.905 96.1441 156.728 97.356C158.551 98.5715 161.791 98.3701 161.791 98.3701C161.791 98.3701 172.928 120.038 182.852 123.684C192.774 127.331 194.191 125.709 195.609 123.077C197.027 120.444 199.659 108.699 189.534 105.66C179.409 102.625 164.018 97.1546 164.018 97.1546L159.158 92.0434L155.716 91.8896C155.716 91.8896 154.298 92.9038 153.488 93.5116",
    fill: "#F7B68B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.909 107.391C148.153 108.061 147.808 108.764 147.136 108.764H114.938C114.266 108.764 113.524 108.061 113.28 107.391L105.099 84.8708C104.855 84.1971 105.2 83.6113 105.871 83.6113H138.07C138.741 83.6113 139.484 84.1971 139.728 84.8708L147.909 107.391Z",
    fill: "#0561FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.61 110.775C159.61 111.445 159.066 111.99 158.395 111.99H115.679C115.008 111.99 114.464 111.445 114.464 110.775V109.98C114.464 109.31 115.008 108.765 115.679 108.765H158.395C159.066 108.765 159.61 109.31 159.61 109.98V110.775Z",
    fill: "#0561FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.932 111.99H117.847C117.847 111.99 112.986 113.634 117.543 119.408C122.1 125.178 126.808 123.571 129.39 122.505C131.971 121.443 140.629 113.502 140.629 113.502L144.274 113.934L148.83 111.8C148.83 111.8 147.767 111.184 146.401 111.792C145.033 112.4 144.274 112.246 144.274 112.246L142.907 111.485L143.818 110.419L144.274 109.357L142.148 110.599L140.932 111.99Z",
    fill: "#EC9568"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.47 68.1388C169.887 64.4482 169.917 59.7105 171.006 53.6181C174.425 34.4695 161.892 67.2857 161.892 67.2857C162.153 68.5891 164.12 72.1515 157.473 79.8146C162.869 78.6503 167.528 74.2934 170.47 68.1388Z",
    fill: "#EC9568"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.158 45.4128C159.158 45.4128 156.12 64.2465 157.336 68.501C158.55 72.7517 162.177 73.7439 166.448 67.8932C174.65 56.653 174.346 47.8439 171.916 46.3245C169.486 44.8087 162.803 39.0349 159.158 45.4128Z",
    fill: "#F7B68B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.322 48.1482C161.372 48.6242 156.728 50.2754 153.691 42.6819C150.653 35.0884 157.336 33.5689 160.676 37.5158C160.906 37.7875 161.119 38.049 161.315 38.3001C163.968 41.6999 163.568 43.1643 161.588 41.4664C160.726 40.7267 160.763 39.3875 161.315 38.3001C162.123 36.7071 164.036 35.6546 165.841 37.8197C167.612 39.9462 168.764 42.6914 169.115 44.5504C169.366 45.8794 169.208 46.7555 168.574 46.6288C167.991 46.512 168.349 45.5437 169.115 44.5504C170.342 42.9581 172.617 41.3015 173.739 42.9858C175.561 45.7208 176.776 49.6677 174.65 50.8832C174.206 51.1367 173.75 51.1523 173.324 51.032C171.708 50.5754 170.537 48.1612 172.22 49.3638C172.658 49.6765 173.031 50.2723 173.324 51.032C174.455 53.9633 174.391 59.3347 172.22 60.3001C169.486 61.5156 169.486 59.3884 171.916 56.9573C174.346 54.5262 171.006 49.5139 169.79 54.3761C169.685 54.7935 168.878 57.5651 168.878 57.5651L167.056 59.0845C167.056 59.0845 167.056 53.6182 168.271 51.6411C171.01 47.1926 170.927 47.0864 164.322 48.1482Z",
    fill: "#212957"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.315 38.3001C163.968 41.6999 163.568 43.1643 161.588 41.4664C160.726 40.7267 160.763 39.3875 161.315 38.3001Z",
    fill: "#212957"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 44.5504C169.366 45.8794 169.208 46.7555 168.574 46.6288C167.991 46.512 168.349 45.5437 169.115 44.5504Z",
    fill: "#212957"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.324 51.032C171.708 50.5754 170.537 48.1612 172.22 49.3638C172.658 49.6765 173.031 50.2723 173.324 51.032Z",
    fill: "#212957"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.646 112.316C142.646 112.316 126.212 113.898 122.084 114.315C119.353 114.59 116.831 115.74 116.126 117.19C116.434 117.856 116.889 118.596 117.543 119.423C122.1 125.193 126.807 123.579 129.39 122.517C131.971 121.451 140.628 113.506 140.628 113.506L144.276 113.946C144.447 113.631 142.954 112.368 142.646 112.316Z",
    fill: "#F7B68B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.238 123.728C194.164 124.479 193.814 125.061 192.069 124.83C189.391 124.471 181.018 119.693 177.05 116.68C170.762 111.906 162.154 98.4175 161.818 98.4248C162.417 99.5781 173.207 120.14 182.852 123.684C191.921 127.016 193.885 125.947 195.238 123.728Z",
    fill: "#EC9568"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 140.875H216.843V139.996H0V140.875Z",
    fill: "#7EB3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4206 151.858L52.3892 146.571L52.6352 136.521L80.107 140.628L78.4206 151.858Z",
    fill: "#EAF4FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7762 136.052L84.287 131.344L94.4855 129.901L123.785 135.276C123.785 135.276 126.167 140.79 123.092 146.271C122.871 146.663 78.0397 153 78.0397 153L52.3312 147.007C52.3312 147.007 49.408 145.334 53.1147 145.755C56.2975 146.117 77.3463 151.525 77.3463 151.525C77.3463 151.525 80.5217 146.758 76.9461 140.977C76.6832 140.548 52.4356 136.986 52.4356 136.986C52.4356 136.986 50.5108 136.799 51.7762 136.052Z",
    fill: "#DD000B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.535 140.212C124.592 137.861 123.232 135.946 123.232 135.946L79.1857 140.984C81.3481 147.212 79.1659 150.903 77.6502 152.561C87.8326 151.225 122.803 146.604 123.004 146.267C123.754 145.015 124.196 143.759 124.435 142.57C124.483 141.695 124.519 140.86 124.535 140.212Z",
    fill: "#FD2227"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5971 138.073L75.8427 141.841L52.559 138.637",
    fill: "#C5E1F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5564 139.494L67.2111 141.76L52.6018 139.798",
    fill: "#C5E1F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.444 144.081L73.4511 148.724L52.4898 144.381",
    fill: "#C5E1F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4872 142.316L77.0347 146.483L52.5329 142.617",
    fill: "#C5E1F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1979 141.365L45.0449 136.715V126.665L72.6094 130.096L71.1979 141.365Z",
    fill: "#EAF4FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1746 126.214L76.5606 120.711L86.7207 119.02L116.143 123.677C116.143 123.677 118.659 129.128 115.72 134.683C115.508 135.082 70.8454 142.514 70.8454 142.514L44.9981 137.15C44.9981 137.15 42.0346 135.554 45.7505 135.883C48.9413 136.165 70.1164 141.057 70.1164 141.057C70.1164 141.057 73.1739 136.209 69.4577 130.52C69.1846 130.102 44.8567 127.133 44.8567 127.133C44.8567 127.133 42.9283 126.99 44.1746 126.214Z",
    fill: "#0561FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.013 128.591C117.013 126.24 115.607 124.358 115.607 124.358L71.697 130.473C74.0113 136.646 71.9199 140.388 70.4455 142.086C80.5921 140.497 115.438 135.024 115.632 134.683C116.35 133.413 116.761 132.146 116.971 130.949C116.998 130.074 117.013 129.239 117.013 128.591Z",
    fill: "#0450CF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0449 128.214L68.3758 131.414L45.0208 128.781",
    fill: "#C5E1F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.039 129.638L59.7446 131.542L45.0917 129.938",
    fill: "#C5E1F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.039 134.226L66.153 138.352L45.0917 134.526",
    fill: "#C5E1F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.039 132.461L69.681 136.023L45.0917 132.761",
    fill: "#C5E1F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9095 131.087L110.311 127.104V118.496L86.7006 121.436L87.9095 131.087Z",
    fill: "#C5E1F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.056 118.112L83.3165 113.396L74.6136 111.946L49.4122 115.937C49.4122 115.937 47.2568 120.609 49.7746 125.365C49.9559 125.705 88.2116 132.072 88.2116 132.072L110.351 127.478C110.351 127.478 112.889 126.108 109.707 126.39C106.974 126.632 88.8363 130.824 88.8363 130.824C88.8363 130.824 86.2173 126.672 89.4005 121.799C89.6344 121.44 110.472 118.895 110.472 118.895C110.472 118.895 112.124 118.775 111.056 118.112Z",
    fill: "#FFAB01"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6667 120.148C48.6667 118.131 49.8716 116.52 49.8716 116.52L87.4826 121.759C85.5 127.046 87.2915 130.249 88.5543 131.707C79.8631 130.345 50.0155 125.658 49.85 125.365C49.2342 124.274 48.8823 123.19 48.7022 122.165C48.6799 121.418 48.6667 120.701 48.6667 120.148Z",
    fill: "#FEC12F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.311 119.825L90.3271 122.564L110.332 120.308",
    fill: "#9AC7F7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.316 121.041L97.7199 122.674L110.27 121.301",
    fill: "#9AC7F7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.316 124.97L92.2306 128.507L110.27 125.226",
    fill: "#9AC7F7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.316 123.461L89.209 126.511L110.271 123.717",
    fill: "#9AC7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramSample);
export default __webpack_public_path__ + "static/media/program_sample.47576ecfc0c8cd4c65abcaf22e3b09bd.svg";
export { ForwardRef as ReactComponent };